/**
 * Dual-ring SVG mastery indicator.
 * Inner ring = Coverage (how many cards have been seen at least once).
 * Outer ring = Competency (FSRS retention rate — % of reviews rated ≥ 3).
 * Both props are 0–1 fractions.
 */
export default function MasteryRing({ coverage = 0, competency = 0, size = 52 }) {
  const innerR = 14;
  const outerR = 20;
  const innerC = 2 * Math.PI * innerR;  // 87.96
  const outerC = 2 * Math.PI * outerR;  // 125.66

  const cap = (v) => Math.min(1, Math.max(0, v || 0));
  const cv = cap(coverage);
  const ct = cap(competency);

  const competencyColor = ct >= 0.8 ? '#00ff88' : ct >= 0.6 ? '#f59e0b' : ct > 0 ? '#ff6b35' : 'var(--text-tertiary)';
  const label = ct > 0 ? `${Math.round(ct * 100)}%` : '—';

  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-label={`Coverage ${Math.round(cv * 100)}%, Competency ${Math.round(ct * 100)}%`}>
      {/* Track rings */}
      <circle cx="24" cy="24" r={outerR} fill="none" stroke="var(--border-color)" strokeWidth="2.5" />
      <circle cx="24" cy="24" r={innerR} fill="none" stroke="var(--border-color)" strokeWidth="3" />

      {/* Competency — outer ring */}
      {ct > 0 && (
        <circle
          cx="24" cy="24" r={outerR}
          fill="none"
          stroke={competencyColor}
          strokeWidth="2.5"
          strokeDasharray={`${ct * outerC} ${outerC}`}
          strokeLinecap="round"
          transform="rotate(-90 24 24)"
          style={{ transition: 'stroke-dasharray 0.7s ease' }}
        />
      )}

      {/* Coverage — inner ring */}
      {cv > 0 && (
        <circle
          cx="24" cy="24" r={innerR}
          fill="none"
          stroke="var(--accent)"
          strokeWidth="3"
          strokeDasharray={`${cv * innerC} ${innerC}`}
          strokeLinecap="round"
          transform="rotate(-90 24 24)"
          style={{ transition: 'stroke-dasharray 0.7s ease' }}
        />
      )}

      {/* Center label — shows competency */}
      <text
        x="24" y="27"
        textAnchor="middle"
        fontSize="8.5"
        fontWeight="700"
        fontFamily="inherit"
        fill={ct > 0 ? competencyColor : 'var(--text-tertiary)'}
      >
        {label}
      </text>
    </svg>
  );
}
